import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'

@Component({
  selector: 'app-tiket-listing-wizard-step3',
  templateUrl: './tiket-listing-wizard-step3.component.html',
  styleUrls: ['./tiket-listing-wizard-step3.component.scss'],
})
export class TiketListingWizardStep3Component implements OnInit {
  @Output() prev = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
